import { gql } from "@apollo/client";

export const SHOP_CATEGORY_FRAGMENT = gql`
  fragment ShopCategoryPart on ShopCategory {
    id
    name
  }
`;

export const SHOP_CATGORIES = gql`
  query ShopCategoriesQuery($where: ShopCategoriesFiltersInput!) {
    shopCategories(where: $where) {
      hasMore
      results {
        ...ShopCategoryPart
      }
    }
  }
  ${SHOP_CATEGORY_FRAGMENT}
`;
